export const LANDING_MEDIA_URL_LO = 'https://testoffers.tilda.ws/';
export const LANDING_MEDIA_URL_UTK = 'https://utkoffer.tilda.ws/';

export const LANDING_FEEDBACK_URL_LO = 'https://project7191539.tilda.ws/';

export const DELIVERY_CODEX_URL_LO = 'https://kodeks.lentaonlinemark.ru/';
